define('editor/edit/map/controls/overlay',['knockout', 'leaflet-tile-wms-nogap'], function (ko) {
    var control = function (options) {
        var self = this;

        self.options = options;
        self.layer = options.layer;
        self.mapControl = options.mapControl;
        self.featureGroup = L.featureGroup();

        self.addToMap = function () {
            if (self.options.layer.visible()) {
                var layerOpts = ko.toJS(self.layer.state);

                self.wmsLayer = new L.TileLayer.WMS.NoGap(layerOpts.url, layerOpts.options);


                self.featureGroup.addTo(self.mapControl);
                self.wmsLayer.addTo(self.featureGroup);
            }
        };

        self.remove = function () {
            if (self.featureGroup) {
                self.featureGroup.clearLayers();
            }
        };

        self.hide = function () {
            self.remove();
        };

        self.show = function () {
            self.addToMap();
        };
    };

    return control;
});

